import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se encacarga de listar tabla direcciones clientes
//CustomerId: id del cliente a consultar
//UserId: id usuario logueado
//PeticionUsuario: Solicitud de permiso para la operacion
export const ObtenerTablaRegistros = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/CustomerEmail/Listado/', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// metodo para crear nuevo registro, recibe:
//const objetoRegistro = {
//    CustomerId: id cliente seleccionado
//    EmailTypeId: id del tipo de correo (cliente/Emailtype)
//    Email: correo electronico
//    Observation: observaciones
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//    PeticionUsuario: Solicitud de permiso para la operacion
//};
export const CrearNuevoRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerEmail/Guardar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se encacarga de la actualizacion de un registro, recibe:
//const objetoRegistro = {
//    CustomerEmailId: id del registro a actualizar (registro cliente/Email),
//    CustomerId: id cliente seleccionado
//    EmailTypeId: id del tipo de correo (cliente/Emailtype)
//    Email: correo electronico
//    Observation: observaciones
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//    PeticionUsuario: Solicitud de permiso para la operacion
//};
export const ActualizarRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerEmail/Actualizar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se encacarga de la validar un registro, recibe:
//const objetoRegistro = {
//    CustomerEmailId: id del registro a actualizar (registro cliente/Email),
//    CustomerId: id cliente seleccionado
//    Email: correo electronico
//};
export const ValidarRegistroEmail = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerEmail/Validar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para eliminar un registro, recibe:
//const data = {
//    CustomerEmailId: id del registro a eliminar (registro cliente/Email),
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//    PeticionUsuario: Solicitud de permiso para la operacion
//};
export const EliminarRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerEmail/Eliminar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se usa para establecer un registro favorito, recibe:
//const objetoRegistro = {
//    CustomerEmailId: id del registro a eliminar (registro cliente/Email),
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//    PeticionUsuario: Solicitud de permiso para la operacion
//};
export const EstablecerFavorito = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerEmail/Favorito/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export const CrearNuevoMail = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerEmail/CorreoNuevoIngreso/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};